// Since these mixins are only used inside our AppData.vue instance, we can use "this" to refer to AppData.

export default {

  computed: {
    propertyKeys () {

      var propertyKeys = [];
      for (var key in this.$store.getters.properties) {
        propertyKeys.push(key);
      };

      return propertyKeys;
    }
  },

  methods: {
    
    // initFilters: This will initialize all the filters in the application. Since we have "All" options for some filters, we need to check at a per-case basis whether or not we need to display it as an option. We'll also check localStorage to see if they already had filters set. This function is long and tedious and could probably be refactored.
    
    initFilters () {
      this.applyLocalStorageSort();
      this.initTicketFilters();
      this.initPeopleFilters();
      this.initUnitFilters();
    },

    applyLocalStorageSort () {
      
      // Check all pages for Local Storage for Sort
      for (var key in this.app.pages) {
        if (localStorage.getItem(key)) {
          
          var pageStorage = JSON.parse(localStorage.getItem(key));

          // Make sure the value exists before applying, in case we change the object and the key no longer exists..
          if (pageStorage.sort && pageStorage.sort.key in this.app.pages[key].sort.options) {
            this.app.pages[key].sort.value = pageStorage.sort.key;
            this.app.pages[key].sort.options[pageStorage.sort.key].value = pageStorage.sort.value;
          }
        }
      }
    },

    initTicketFilters () {
      if (!this.hasPermissions(['ticket', 'ticketManager', 'ticketAdmin'])) return;

      var ticketFilters = localStorage.getItem('tickets') ? JSON.parse(localStorage.getItem('tickets')) : false;
      
      var options = this.getOptionsFromProperties(['ticket', 'ticketManager', 'ticketAdmin']);
      var selected = options[0].value;

      // check the property is in the ticket filters
      if (ticketFilters && ticketFilters.property) {
        if (this.valueInOptions(ticketFilters.property, options)) {
          selected = ticketFilters.property;
        }
      }

      Vue.set(this.app.pages.tickets.filtering.filters.property, 'options',  [...options]);
      Vue.set(this.app.pages.tickets.filtering.filters.property, 'value', selected);

      // Statuses
      options = [];
      for (var status in this.$store.getters.company.statuses) {
        options.push({
          value: status,
          title: status.charAt(0).toUpperCase() + status.substring(1, status.length) // I'm sorry
        });
      }

      // Create Unresolved status
      options.unshift({
        value: 'unresolved',
        title: 'Unresolved'
      });

      selected = options[0].value;

      // Check the status is in the ticket filters
      if (ticketFilters && ticketFilters.status) {
        if (this.valueInOptions(ticketFilters.status, options)) {
          selected = ticketFilters.status;
        }
      }

      Vue.set(this.app.pages.tickets.filtering.filters.status, 'options',  [...options]);
      Vue.set(this.app.pages.tickets.filtering.filters.status, 'value', selected);

      // Ticket Tags
      options = [];
      for (var key in this.$store.getters.ticketTags) {
        options.push({
          title: this.$store.getters.ticketTag(key).title,
          value: key
        });
      }
      
      if (options.length > 1) {
        options.unshift({
          title: 'All',
          value: 'all'
        })
      }
      
      selected = options[0].value;

      // Check the ticket tag is in the ticket filters
      if (ticketFilters && ticketFilters.type) {
        if (this.valueInOptions(ticketFilters.type, options)) {
          selected = ticketFilters.type;
        }
      }

      Vue.set(this.app.pages.tickets.filtering.filters.type, 'options',  [...options]);
      Vue.set(this.app.pages.tickets.filtering.filters.type, 'value', selected);
    },

    initPeopleFilters () {
      if (!this.hasPermissions(['user'])) return;
  
      // People Local Storage
      var peopleFilters = localStorage.getItem('joined') ? JSON.parse(localStorage.getItem('joined')) : false;

      // This determines which tab will open when the user chooses the "People" tab
      // This needs to be done first because any changes to the filter will be watched, and if this value doesn't match the current value in the filter, it will redirect the user
      this.app.navigation.people.target = peopleFilters && peopleFilters.people ? peopleFilters.people : 'joined';
      
      // Properties
      var options = this.getOptionsFromProperties(['user']);
      
      var selected = options[0].value;

      // Check the property is in the people filters
      if (peopleFilters && peopleFilters.property) {
        if (this.valueInOptions(peopleFilters.property, options)) {
          selected = peopleFilters.property;
        }
      }

      Vue.set(this.app.pages.joined.filtering.filters.property, 'options',  [...options]);
      Vue.set(this.app.pages.joined.filtering.filters.property, 'value', selected);
      
      // Role Templates
      if (this.hasPermissions(['role'])) {

        var options = [];
        
        for (var key in this.$store.getters.roleTemplates) {
          options.push({
            title: this.$store.getters.roleTemplate(key).title,
            value: key
          });
        }
        
        options.sort((a, b) => {
          a.title < b.title ? -1 : 1;
        });
      
        if (options.length > 1) {
          options.unshift({
            title: 'All',
            value: 'all'
          })
        }
                
        var selected = options[0].value;

        // Check the property is in the people filters
        if (peopleFilters && peopleFilters.role) {
          if (this.valueInOptions(peopleFilters.role, options)) {
            selected = peopleFilters.role;
          }
        }

        Vue.set(this.app.pages.joined.filtering.filters.role, 'options',  [...options]);
        Vue.set(this.app.pages.joined.filtering.filters.role, 'value', selected);

        // Joined vs Invited
        
        if (peopleFilters && peopleFilters.people) {
          Vue.set(this.app.pages.joined.filtering.filters.people, 'value', peopleFilters.people);    
        }
      }
    
      /* 
        HOWITWORKS - For the Invites filter to work properly, invites.filtering.filters MUST be a reference to people.filtering.filters. This is because per the original design, the People page techincally contains the Invites page, which means the filters for People and Invites are exactly the same. The filters are actually used to determine if we show the "People" page or the "Invites" page. Since this loads different components (ie: InviteDetails vs PeopleDetails), it makes more sense to store all the data in separate app.page objects, but means we have to use this hack to make it work with the code structure.
      */

      this.app.pages.invited.filtering = this.app.pages.joined.filtering;
    },

    initUnitFilters () {
      if (!this.hasPermissions(['unit'])) return;

      // Unit Local Storage
      var unitFilters = localStorage.getItem('units') ? JSON.parse(localStorage.getItem('units')) : false;

      // Properties
      var options = this.getOptionsFromProperties(['unit']);
      var selected = options[0].value;

      // Check the property is in the unit filters
      if (unitFilters && unitFilters.property) {
        if (this.valueInOptions(unitFilters.property, options)) {
          selected = unitFilters.property;
        }
      }

      Vue.set(this.app.pages.units.filtering.filters.property, 'options',  [...options]);
      Vue.set(this.app.pages.units.filtering.filters.property, 'value', selected);

      // Because Unit Types are specific to Properties, this filter needs to be reinitialized each time the property changes. This means having the logic for initializing the Unit Type filters makes sense.
      this.initUnitTypeFilters();
    },

    // This happens every time the user changes the Unit properties filter
    initUnitTypeFilters () {      

      var options = [];

      new Promise((resolve, reject) => {

        if (this.app.pages.units.filtering.filters.property.value && this.app.pages.units.filtering.filters.property.value !== 'all') {
          this.$store.dispatch('loadUnitTypes', {
            company: this.$store.getters.company._id,
            property: this.app.pages.units.filtering.filters.property.value
          })  
          .then(data => {
            resolve(data);
          })
        }
        else {
          resolve();
        }
          
      })
      .then(data => {
        
        if (data) {
          options = [];
          data.forEach(unitType => {
            options.push({
              title: unitType.name,
              value: unitType._id
            });
          });
          
          options = options.sort((a, b) => {
            return a.title < b.title ? -1 : 1;
          });
        }
        
        options.unshift({
          title: 'All',
          value: 'all'
        })

        // Unit Local Storage
        var unitFilters = localStorage.getItem('units') ? JSON.parse(localStorage.getItem('units')) : false;
        var selected = options[0].value;

        // Check the property is in the people filters
        if (unitFilters && unitFilters.type) {
          if (this.valueInOptions(unitFilters.type, options)) {
            selected = unitFilters.type;
          }
        }
        
        // Overwrite unit type local storage
        var current = {};
        if (localStorage.getItem('units')) {
          current = JSON.parse(localStorage.getItem('units'));
          current['type'] = selected;
          localStorage.setItem('units', JSON.stringify(current));
        }
        
        Vue.set(this.app.pages.units.filtering.filters.type, 'options',  [...options]);
        Vue.set(this.app.pages.units.filtering.filters.type, 'value', selected);
      })
      .catch(e => {
        console.log(e);
      });
    },

    // Get Properties user should be able to see, add "All" Option if the user has more than 1. Used throughout this function to prepare property filters.
    getOptionsFromProperties (permissions) {

      var options = [];

      this.getAccessiblePropertiesList(permissions).forEach(p => {
        options.push({
          title: p.name,
          value: p._id
        });
      });

      options.sort((a, b) => {
        a.title < b.title ? -1 : 1;
      });

      if (options.length > 1) {
        options.unshift({
          title: 'All',
          value: 'all'
        })
      }
      
      return options;
    },

    // This is a helper function for the initFilter functions, it ensures a value set from local storage exists in option list the user has (if they have an option removed, it will make sure the localStorage doesn't set the filter to a non-existing filter option)
    valueInOptions (value, options) {
      for (var i = 0; i < options.length; ++i) {
        if (options[i].value === value) {
          return true;
        }
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AppData/initFiltersMixin.js